import axios from "axios";

import config from "../../config";
import { HelpPlayUrls, HelpVideoList, HelpVideoQuery } from "./types";

const BASE = `${config.apiServerUrl}/users/help-videos`;

/** Help videos the user may see, filtered and paged (see HelpVideoQuery), with signed posters. */
export const getHelpVideos = (query: HelpVideoQuery): Promise<HelpVideoList> =>
  axios.get<HelpVideoList>(BASE, { params: query }).then((res) => res.data);

/**
 * Signed links for one play; `from` is the page it was played on. A first call is one play in the usage
 * report; `refresh` marks a re-sign after a load error (expired link) so it isn't counted again.
 */
export const getHelpPlayUrls = (videoId: string, locale: string, from: string, refresh = false): Promise<HelpPlayUrls> =>
  axios
    .get<HelpPlayUrls>(`${BASE}/${encodeURIComponent(videoId)}/play-url`, {
      params: { locale, from, ...(refresh ? { refresh: 1 } : {}) },
    })
    .then((res) => res.data);
